<template>
  <div class="page final">
    <main>
      <div class="citybg"></div>
      <div class="ornamentline"></div>
      <levensweg-header icon="?"></levensweg-header>
      <header class="header--final">
        <div class="headercont">
          <h2 class="titleslide--final" >Ja, <br />ik wil kinderen.</h2>
          <p class="bodyslide--final">Wil jij wél ooit kinderen? Lijkt het opvoeden van één of meerdere koters voor jou heel zinvol? Sta dan even stil bij deze wens en bespreek het met jouw partner. Wat moet je bijvoorbeeld nog gedaan hebben voor je de grote stap zet? </p>
          <levensweg-button class="btn--final" label="Ontdek de feiten" color="blue down" link="#facts" type />
        </div>
        <div class="babylyingcontainer">
          <img src="./../assets/img/babylying.svg" class="babylying" />
        </div>
      </header>
      <section class="infosection" id="facts">
        <div class="leftblok">
          <header>
            <h3 class="sectiontitle">Wist je dat?</h3>
            <p class="sectionintro">De vruchtbaarheid van de vrouw begint te dalen na 30 jaar? Op 35 jarige leeftijd ben je als vrouw maar half zo vruchtbaar als toen je 25 was. </p>
          </header>
          <div class="articleblocks">
            <article>
              <h4 class="articletitle">Wat na de leeftijd van 35?</h4>
              <p class="articlebody">Na de leeftijd van 35 daalt de vruchtbaarheid snel en op 40-jarige leeftijd zijn vrouwen maar half zo vruchtbaar als ze op 35-jarige leeftijd waren. Op die leeftijd is er ook 50% kans op een miskraam.  </p>
            </article>
            <article>
              <h4 class="articletitle second">En de man?</h4>
              <p class="articlebody">De vruchtbaarheid van de man wordt vooral bepaald door de leeftijd van zijn vrouwelijke partner, maar recente studies tonen dat er ook bij mannen een invloed is van leeftijd op de spermakwaliteit. </p>
            </article>
           </div>
        </div>
        <div class="rightblok">
          
          <aside class="parentsaside">
                <img src="./../assets/img/parents.svg" class="parents" />
          </aside>
          <div class="rightblock__line"/>
        </div>
      </section>
      
      <!--section class="testimonialsection"  id="testimonials">
        <article>
          <aside>
            <img src="https://via.placeholder.com/320x330" alt="" width="320" height="330">
          </aside>
          <header>
            <h3 class="sectiontitle" >Hun verhaal</h3>
            <p  class="sectionintro">“Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna”</p>
          </header>
          <p class="articlebody noheading">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor...</p>
          <a href="">Bekijk</a>
          <a href="">Lees</a>
        </article>
      </section-->
      <section class="infosection plan" id="plan">
        <div class="rightblok ivfblok">
          <aside class="parentaside">
              <img src="./../assets/img/ivf_final.svg" class="ivf" />
          </aside>
          <div class="rightblock__line__flipped"/>
        </div>
        <div class="planningtop">
          <header>
            <h3 class="sectiontitle">Zorg voor een plan</h3>
            <p class="sectionintro">Als je écht graag kinderen wil, zorg dan voor een plan. Kinderen vragen veel tijd, maar het leven stopt niet als ze er zijn.</p>
          </header>
          <article>
            <h4 class="articletitle">Zijn er andere technieken?</h4>
            <p class="articlebody">De kinderwens uitstellen tot na de leeftijd van 35 jaar is dus niet zonder risico. Ook de slaagkansen van IVF en andere medisch begeleide voortplantingstechnieken worden sterk bepaald door leeftijd. Jammer genoeg moeten een aantal koppels hun kinderwens bijstellen (ze krijgen minder kinderen dan ze wilden) of ze blijven ongewenst kinderloos. </p>
          </article>
        </div>
      </section>
      <levensweg-footer class="footer"/>
    </main>
  </div>
</template>

<script>
import Footer from './../components/Footer';
import Header from './../components/Header';
import Levenswegbutton from './../components/Levenswegbutton';


export default {
  components:{
    'levensweg-footer':Footer,
    'levensweg-header':Header,
    'levensweg-button':Levenswegbutton
  }
}
</script>

<style>
.footer{
  margin-left: 1.8rem;
  margin-right: 1.8rem;
  margin-bottom: 4rem;
}

.planningtop{
  margin-top: 2.2rem;
}

.rightblok{
  display: flex;
  flex-direction: column;
  
  margin-top: 8rem;
  margin-bottom: 6.2rem;
  margin-left:-1.8rem;
  margin-right:-1.8rem;
}
.parentsaside{
  align-self: center;
}
.rightblock__line{
  align-self: flex-end;
  position: absolute;
  background: url("../assets/img/line_path.svg") 0 0 no-repeat;
  background-position-x: right;
  width: 231px;
  height: 368px;
  z-index: -1;
  margin-top: -5.5rem;
}
.rightblock__line__flipped{
  align-self: flex-end;
  position: absolute;
  background: url("../assets/img/line_ivf.svg") 0 0 no-repeat;
  background-position-x: right;
  width: 259px;
  height: 402px;
  z-index: -1;
  margin-top: -7.0rem;
  
}
.rightblok:after{
  content: "";
  position: absolute;
  z-index: -2;
  background: url("../assets/img/oval_end_side.svg") 0 0 no-repeat;
  background-position-x: right;
  width:100%;
  height:368px;
  margin-top: -3.0rem;
}
.rightblok.ivfblok:after{
  margin-top: 2rem;
}



.parents{
  width: 232px;
  height: 319px;
}
.ivf{
  width: 342px;
  height: 324px;
}

.babylyingcontainer{
  margin-left:calc(-26.13%*2);
  margin-top:-4rem;
  margin-bottom: 8rem;
  z-index: -2;
  text-align: right
}

.babylying{
  width: auto;
  height: 291px;
  object-fit: cover;
  
}
.ornamentline{
    background-image:url("../assets/img/line.svg");
    background-repeat: no-repeat;
    background-size: contain;
    width: 254.4px;
    height: 496px;
    position: absolute;
    z-index: -2;
  }
  .citybg{
    background-image:url("../assets/img/city.svg");
    background-repeat: no-repeat;
    background-position: -150px 82px;
    background-size: auto 364px;
    width: 100%;
    height:100%;
    z-index: -2;
    position: absolute;
  }

  .header--final{
    display: flex;
    flex-direction: column;
  }
  .infosection{
    display: flex;
    flex-direction: column;
  }
  .articleblocks{
    display: flex;
    flex-direction: column;
  }
  .infosection, .testimonialsection{
    margin-left: 1.8rem;
    margin-right: 1.8rem;
  }

  .sectiontitle{
    font-family: Montserrat;
    font-size: 1.1rem;
    text-transform: uppercase;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    margin-bottom: 2rem;
    color: var(--orange);
  }

  .sectionintro{
    font-family: "Playfair Display";
    font-size: 2rem;
    color: var(--titleslidecolor);
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.5;
    letter-spacing: normal;
  }

  .articletitle{
    font-family: "Playfair Display";
    font-size: 1.6rem;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    color: var(--titleslidecolor);
    margin-top: 4rem;
    margin-bottom:2rem;
  }

  .articletitle.second{
    margin-top: 3rem
  }

  .articlebody{
    font-family: Montserrat;
    font-size: 1.3rem;
    font-weight: 300;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.54;
    letter-spacing: normal;
    color:var(--articlebodycolor);
    margin-right: 4.4rem;
  }
  .articlebody.noheading{
    margin-top: 3rem;
  }

  .titleslide--final{
    font-family: "Playfair Display";
    font-size: 6rem;
    font-weight: 900;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.08;
    letter-spacing: normal;
    color: var(--titleslidecolor);
    
    /*animation: fadeandmove 0.8s ease-out 0s;*/
    animation-name: movetitleslide1, fade;
    animation-timing-function: ease-out, ease-in;
    animation-duration: 0.5s, 1s;
    word-break: word-break;
    hyphens: manual;
  }
  .bodyslide--final{
    font-family: Montserrat;
    font-weight: 300;
    font-size: 1.3rem;
    line-height: 1.54;
    letter-spacing: normal;
    color: var(--bodyslidecolor);
    margin: 3.5rem 0 0 0;
    width:26.6rem;
    animation-name: fade;
    animation-timing-function: ease-in;
    animation-duration: 0.5s;
    animation-delay: 0.8s;
    animation-fill-mode: backwards;
  }
  .btn--final a{
    margin-left:0;
  }

  .header--final{
    margin: 14.4rem 14.6% 0 14.6%;
  }

/* tablet */
@media only screen and (min-width: 768px) {
  .page{
    position: relative;
  }
  
  .babylyingcontainer{
    margin-left: 0;
    margin-bottom: 6rem;
    margin-right: 2rem;
  }
  .babylying{
    width: 80%;
    max-width: 457px;
    height:80%;
    max-height: 374px;
  }
  .infosection{
    flex-direction: row;
    align-items: flex-end;
  }
  .header--final{
    flex-direction: row-reverse;
    margin-left:1.8rem;
    margin-right:1.8rem;
    align-items: flex-end;
    margin-bottom:8rem;
  }
  .header--final div {
    flex:50%;
  }

  .sectionintro{
    width:75%;
  }
   .rightblok:after {
    display: none;
  }
  .infosection:after{
    content: "";
    position: absolute;
    z-index: -2;
    background: url("../assets/img/oval_end_side.svg") 0 0 no-repeat;
    background-position-x: right;
    width:80%;
    height:80%;
    margin-top: 3rem;
    right: 0;
  }
  .infosection.plan:after{
    content: "";
    position: absolute;
    z-index: -2;
    background: url("../assets/img/oval_end_side.svg") 0 0 no-repeat;
    background-position-x: right;
    width:80%;
    height:80%;
    margin-top: 3rem;
    left: 0;
    transform: rotate(180deg);
  }
  .rightblock__line__flipped{
    align-self: flex-start;
  }
  .parentsaside{
    align-self: flex-start;
  }
  .titleslide--final{
    width: 100%;
    max-width:400px;
  }

 

}




@media only screen and (min-width: 992px) {

  #facts .articlebody{
    width: 75%;
  }

  .header--final{
    flex-direction: row-reverse;
  }
   .citybg{
    background-size: contain;
    background-position-x: 0px;
  }

  .infosection{
    flex-direction: row;
    align-items: flex-start;
  }
  .infosection.plan{
    flex-direction:row-reverse;
    justify-content: space-between;
  }
  .articleblocks{
    flex-direction: row;
  }

  .articleblocks article{
    flex:50%;
  }
  .planningtop .articlebody{
    width:50%;
  }

  .sectionintro{
    width: 70%;
  }
  .ornamentline{
    background-image:url("../assets/img/line.svg");
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center center;
    width: 100%;
    height: 50%;/*496px;*/
    position: absolute;
    z-index: -2;
  }
}
@media only screen and (min-width: 1200px) {

  .titleslide--final{
    font-size: 8rem;
    line-height: 1.06;
  }
  .ornamentline{
    width: 100%;
    height: 496px;
  }

  .babylyingcontainer{
    margin-right: 123px;
  }
  .header--final{
    margin-top: 81px;
  }

  .citybg{
    background-position-y: 18px;
    background-position-x: -83px;
  }

  .bodyslide--final{
    font-size: 1.5rem;
    width: 34.2rem;
    line-height: 1.47;
  }
  .sectiontitle{
    font-size: 1.3rem;
    margin-bottom: 2.2rem;
  }
  .sectionintro{
    font-size: 3rem;
  }
  .articletitle{
    font-size: 2rem;
    margin-top: 7.5rem;
  }
  .articletitle.second{
    margin-top:7.5rem;
  }
  .articlebody{
    font-size: 1.5rem;
  }
  .plan .articlebody{
    width: 40.9rem;
  }
  .page.final{
    height: auto;
    max-width: 1200px;
    margin:0 auto;
    padding-left: 83px;
    padding-right: 84px;
    overflow: hidden;
    
  }
  .btn--final{
    margin-top: 4rem;
  }
}



</style>


